(() => {
  'use strict';

  angular
    .module('specsguardApp')
    .controller('sgExpansionFooterController', sgExpansionFooterController);

  sgExpansionFooterController.$inject = ['$scope', 'sgExpansionPanelFactory', 'Labels'];

  function sgExpansionFooterController ($scope, sgExpansionPanelFactory, Labels) {
    $scope.LABELS = Labels;
    $scope.closeAll = () => {
      $scope.cancel();
      sgExpansionPanelFactory.closeAll();
    };

    $scope.updateValue = () => {
      $scope.save();
      sgExpansionPanelFactory.closeAll();
    };
  }
})();
